import type { FaireProductEntity } from "../../entity_types/product";

export const p_ezjx8qsjp8: FaireProductEntity = {
  token: "p_ezjx8qsjp8",
  type: "product",
  name: "Mushroom Dress",
  brandToken: "b_2y1von4s08",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/c3c14551ec8424f959e0ed9d6d2f151a142f0cf4e231717b5b2f7bc3df38d460.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/819aaee202fa12fee93eab54d2f52ad7aca9fadc36f30a5f7d1d0e133929549d.jpeg",
    "https://cdn.faire.com/fastly/7ed60dfb32074add24bf3681882cb7c970dd6654bad82e20bfdd489323b471a2.jpeg",
    "https://cdn.faire.com/fastly/faeafed9fb5b7d6b715f0a190928b4c1cefd87b453d57be69db5cd09956c27e2.jpeg",
    "https://cdn.faire.com/fastly/39a7d70583a03eecf0e37fc381dfd9b991181cf027ea628b3ea3645fb245ff65.jpeg",
    "https://cdn.faire.com/fastly/cde34cb2b5006c8bb3618781f7ca975a1709707ef8c628c5fe455f82ffb37544.jpeg",
    "https://cdn.faire.com/fastly/7e7f46465f63070e4d1fc0657ce5ee138ee22c17495ce492fb9027dfdeb84627.jpeg",
    "https://cdn.faire.com/fastly/5cec204090fa677b0acce9f79912c528e3863dfd916e4707ec371cbcfcd13c57.jpeg",
    "https://cdn.faire.com/fastly/87c74b9e6287ca5ccf915f782efa2e398a9cf9d4f77c7fac1eb391661e06611c.jpeg",
  ],
  priceDollars: 29.21,
  description:
    "Mushroom print short-sleeved cotton dress in khaki or maroon. Comfortable to wear in strong and breathable cotton, it has a round neckline with an open seamed 'V' feature. A flatteringly high under-bust seam flows into a slightly gathered long skirt in two layers of fabric with two side seam pockets. Trendy matching accessories and unisex separates are available.\n\n100% Cotton\n\nWomens Fit. Introducing a new range of boho clothing and complementary accessories in stunning colours, fashionable prints and flattering lines. Skilled artisans employ intensive methods such as block printing, hand screen printing, tie dying and patchworking to achieve stylish comfort, freedom of movement and durability for working and playing hard.\n\nHandwash in cold water. Warm iron.\n\nOur main supplier in Kathmandu is a member of the Fair Trade Group Nepal and has a social program to train and rehabilitate 'Kamlari' girls who have escaped from a life of servitude.",
  tags: [],
  msrpDollars: 58.41,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:35.314Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
